import type { MsgTransfer } from 'cosmjs-types/ibc/applications/transfer/v1/tx'
import { CHAIN_CONFIG } from '@/config'
import { MetaDataHandlerParameters } from './types'
import { CHAIN_INFO_LIST } from '@/config'

const handleIbc = ({
  message,
  strideAddress,
  selectedAddress,
  denom
}: MetaDataHandlerParameters<MsgTransfer>): boolean => {
  if (message.token == null) {
    return false
  }

  if (message.token.denom.startsWith('st')) {
    return false
  }

  const isDepositingToStride =
    message.sender === selectedAddress &&
    message.receiver === strideAddress &&
    message.token.denom === CHAIN_INFO_LIST[denom].stakeCurrency.coinMinimalDenom

  const isWithdrawingFromStride =
    message.sender === strideAddress &&
    message.receiver === selectedAddress &&
    message.token.denom === CHAIN_CONFIG[denom].ibcDenom

  return isDepositingToStride || isWithdrawingFromStride
}

export { handleIbc }
